<template>
    <div :width="width" class="menuAside">
        <el-tree ref="tree" :data="data"
                 :props="treeConfig"
                 highlight-current
                 :node-key="nodeKey"
                 :default-expanded-keys="expandedKeys"
                 @node-click="selTree">
      <span slot-scope="{node,data}" class="custom-tree-node">
         <i class="el-icon-folder" style="font-size: 16px;line-height: 21px;color:#dbc431"></i>
        <span :title="node.label" style="font-size: 16px;" class="em-tree-text">
            {{ node.label }}
        </span>
      </span>
        </el-tree>
    </div>
</template>

<script>
    export default {
        name: "menuTree",
        props: {
            data: {
                type: Array,
                default: () => []
            },
            treeConfig: {
                type: Object,
                default: () => {
                    return {
                        children: 'children',
                        label: 'name',
                    }
                }
            },
            width: {
                type: String,
                default: '280px'
            },
            expandedKeys: {
                type: Array,
                default: () => []
            },
            nodeKey: {
                type: String,
                default: 'id'
            },
        },
        // props: ['data', 'treeConfig', 'width', 'expandedKeys', 'nodeKey'],
        data() {
            return {}
        },
        mounted() {
        },
        methods: {
            // 节点点击事件
            selTree(data) {
                this.$emit('selTree', data)
            },
            setkey(key) {
                this.$nextTick(() => {
                    this.$refs.tree.setCurrentKey(key)
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .menuAside {
        padding-bottom: 10px;
        position: relative;
        width: auto !important;
        height: 40vh;
    }

    ::v-deep .el-tree-node{
        text-align: left;

        .is-leaf {
            margin-right: 5px;
            height: 5px;
            width: 5px;
        }
        :nth-child(2) {
            padding: 1px;
            overflow: visible;
        }
    }
    ::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
        min-width: 90%;
        background-color: #409eff;
        border-radius: 10px;
        color: white;
        display: inline-block;
    }

    ::v-deep .el-tree-node__content {
        position: relative;
        width: auto;
        padding: 5px;
        margin-bottom: 1px;
        cursor: pointer;
        color: black;

        display: inline-block;
        &:hover {
            min-width: 90%;
            background-color: #409eff;
            border-radius: 10px;
            -webkit-transition: background-size .3s linear;
            transition: background-size .3s linear;
        }
    }
</style>